<script setup>
import ScrollingContainer from '@/__core__/containers/scrolling-container/ScrollingContainer.vue'
import EventsOverview from '@/__v1.5__/composits/key-moments/EventsOverview.vue'
import { computed, inject, ref } from 'vue'

const props = defineProps({
  events: Array
})

const widgetHeight = inject('height', ref(0))
const isLargeWidget = inject('isLargeWidget')

/** @type {Ref<HTMLDivElement>} */
const eventsContainerRef = ref(null)

const containerId = computed(() => `events-container-${props.events?.length || 0}`)

const buttonOffset = computed(() => (isLargeWidget.value ? 16 : 8))
</script>

<template>
  <div class="szw-flex szw-flex-col szw-w-full szw-h-full szw-max-w-[768px] szw-mx-auto">
    <scrolling-container :widget-container-height="widgetHeight" :container-ref="eventsContainerRef" :container-id="containerId" :button-offset="buttonOffset">
      <div class="szw-scrollable-container" ref="eventsContainerRef">
        <events-overview :events="events" />
      </div>
    </scrolling-container>
  </div>
</template>
